module.exports = __webpack_public_path__ + "static/hero-60703134f39985f76a536820d7badde8.png";